import { Route } from "react-router-dom";
import PortalGuard from "../components/PortalGuard";
import AdminLayout from "../layouts/AdminLayout";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminUsers from "../pages/admin/AdminUsers";
import AdminGames from "../pages/admin/AdminGames";
import AdminShops from "../pages/admin/AdminShops";
import AdminPublishers from "../pages/admin/AdminPublishers";
import AdminRules from "../pages/admin/AdminRules";
import AdminTutorials from "../pages/admin/AdminTutorials";
import AdminReports from "../pages/admin/AdminReports";
import AdminVerification from "../pages/admin/AdminVerification";
import AdminAudit from "../pages/admin/AdminAudit";
import AdminAnalytics from "../pages/admin/AdminAnalytics";
import AdminPlans from "../pages/admin/AdminPlans";
import AdminCampaigns from "../pages/admin/AdminCampaigns";
import AdminCommunity from "../pages/admin/AdminCommunity";
import AdminAttendance from "../pages/admin/AdminAttendance";
import AdminMonetization from "../pages/admin/AdminMonetization";
import AdminCollections from "../pages/admin/AdminCollections";
import AdminVerificationManager from "../pages/admin/AdminVerificationManager";
import AdminDiagnostics from "../pages/admin/AdminDiagnostics";

export function AdminRoutes({ ProtectedRoute }) {
  return (
    <Route
      path="/admin"
      element={<ProtectedRoute><PortalGuard portal="admin_portal"><AdminLayout /></PortalGuard></ProtectedRoute>}
    >
      <Route index element={<AdminDashboard />} />
      <Route path="users" element={<AdminUsers />} />
      <Route path="games" element={<AdminGames />} />
      <Route path="shops" element={<AdminShops />} />
      <Route path="publishers" element={<AdminPublishers />} />
      <Route path="rules" element={<AdminRules />} />
      <Route path="tutorials" element={<AdminTutorials />} />
      <Route path="reports" element={<AdminReports />} />
      <Route path="verification" element={<AdminVerification />} />
      <Route path="audit" element={<AdminAudit />} />
      <Route path="analytics" element={<AdminAnalytics />} />
      <Route path="plans" element={<AdminPlans />} />
      <Route path="campaigns" element={<AdminCampaigns />} />
      <Route path="community" element={<AdminCommunity />} />
      <Route path="attendance" element={<AdminAttendance />} />
      <Route path="monetization" element={<AdminMonetization />} />
      <Route path="collections" element={<AdminCollections />} />
      <Route path="venue-verification" element={<AdminVerificationManager />} />
      <Route path="diagnostics" element={<AdminDiagnostics />} />
    </Route>
  );
}
